module.exports = __webpack_public_path__ + "img/classicdrawing.bd7daf0.jpg";